import styled from 'styled-components'
import theme from '../../../../styles/theme'
import { media } from '../../../../styles/utils'

export const Wrapper = styled.div`
  flex-basis: 33.333%;
  line-height: 2.9rem;
  padding: 0 0.6rem;
  margin: 8px;
  text-align: center;
  border: ${theme.borderDefault};

  ${media.sm`
    line-height: 1rem;
    padding: 0.65rem 0;
    margin: 4px;
  `};
`

export const Title = styled.h4`
  margin: 0px;
  font-size: ${theme.headingCheckout};
  font-family: ${theme.brandFontFamily};
  font-weight: 400;
  color: ${props =>
    props.active ? theme.brandFontColor : theme.bodyFontColor};

  ${media.sm`
    font-size: 0.9rem;
    white-space: nowrap;
  `};

  ${media.xs`
    font-size: 0.75rem;
    white-space: nowrap;
  `};
`
